const body = $('body');

const isMobile = {
    Android: () => navigator.userAgent.match(/Android/i),
    BlackBerry: () => navigator.userAgent.match(/BlackBerry/i),
    iOS: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
    Opera: () => navigator.userAgent.match(/Opera Mini/i),
    Windows: () => navigator.userAgent.match(/IEMobile/i),
    any() {
        return this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows();
    }
};

function isIE() {
    let ua = navigator.userAgent;
    return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
}

if (isIE()) body.addClass('ie');
if (isMobile.any()) body.addClass('touch');